import { Component, Input } from '@angular/core';

@Component({
  selector: 'agratio',
  template: `
 
       <progress id="file" [value]="value" max="365"> {{value}}% </progress>
`,
styles: [`
  svg {
      width: 100%;
      height: 100%;
      pointer-events: none;
  }

  .topBar {
      fill: #a258df;
  }

  .bottomBar {
      fill: #6699ff;
  }
  progress[value]::-webkit-progress-bar {
    // background-color: #eee;
    background-color: rgb(206 202 202) !important;
    border-radius: 2px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) inset;
  }

  progress[value]::-webkit-progress-value {
    // background-image:
    //    -webkit-linear-gradient(-45deg, 
    //                            transparent 33%, rgba(0, 0, 0, .1) 33%, 
    //                            rgba(0,0, 0, .1) 66%, transparent 66%),
    //    -webkit-linear-gradient(top, 
    //                            rgba(255, 255, 255, .25), 
    //                            rgba(0, 0, 0, .25)),
    //    -webkit-linear-gradient(left, #09c, #f44);
  
    //   border-radius: 2px; 
    //   background-size: 35px 20px, 100% 100%, 100% 100%;
    background: #a258df;
  }

  progress[value] {
    -webkit-appearance: none;
     appearance: none;
     width: 100%;  
  }

`]
})
export class AgratioComponent {
  @Input() value:any;
  @Input() params:any;
  docNo:any = '';
  constructor() {
  }

  ngOnInit(){
    this.value = parseFloat(this.value||0)
    this.docNo = this.params.data.DocNo;
  }

}



// WEBPACK FOOTER //
// ./src/components/agGridRenderer/agratio/agratio.ts